<template>
  <div class="index-home">
    <div class="content">
      <div class="ly-card apply">
        <h3>流程快速申请</h3>
        <ul class="item-ul">
          <li @click="goto('/personal/teach')">代课申请</li>
          <li @click="goto('/personal/teach')">教师替换申请（开课前）</li>
          <li @click="goto('/personal/teach')">教师替换申请（开课后）</li>
        </ul>
      </div>
      <div class="ly-card sys">
        <div class="hd">
          <div>
            <h3>系统消息</h3>
          </div>
          <el-button type="text" v-if="page.total" @click="gotoAll('/personal/message')">操作</el-button>
          <span v-else>无</span>
        </div>
        <ul class="item-ul">
          <li :class="item.has_read || 'no-read'" @click="showDetail(item)" v-for="item in sysMessage" :key="item.id">
            <div class="info">{{ item.title }}</div>
            <div class="time">{{ item.create_time }}</div>
          </li>
        </ul>
        <el-pagination
          :current-page="page.page_no"
          :page-size="5"
          @current-change="currentChange"
          v-show="page.total > 5"
          layout="prev, pager, next"
          :total="page.total"
        >
        </el-pagination>
      </div>
      <div class="ly-card">
        <div>部门班级分布图</div>
        <pie-chart :dataArr="dataArr" :isPercentText="false" @percent="percentSet"></pie-chart>
      </div>
      <div class="ly-card">
        <el-select
          size="small"
          v-model="year"
          style="width: 150px"
          class="m-r-30 m-b-15"
          @input="chart"
          placeholder="所属学年"
        >
          <el-option v-for="item in years" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select @input="chart" size="small" v-model="term" style="width: 150px" placeholder="所属学期">
          <el-option v-for="item in terms" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <table class="native-table">
          <tr>
            <th>部门名称</th>
            <th>班级数量</th>
            <th>占比</th>
          </tr>
          <tr v-for="(item, index) in dataArr" :key="item[1]">
            <td>
              <div class="title-hd">
                <span class="color-block" :style="{ background: item[1] }"></span>
                <span>{{ item[2] }}</span>
              </div>
            </td>
            <td>{{ item[0] }}</td>
            <td>{{ percent[index] }} %</td>
          </tr>
        </table>
      </div>
    </div>
    <sys-message :visible.sync="isShow" :curItem="curItem" />
  </div>
</template>

<script>
import { Select, Option, Pagination } from 'element-ui';
import PieChart from '@/components/PieChart';
import { pieChart, sys } from '@/api';
import SysMessage from '@/components/SysMessage';

const Decimal = require('decimal.js/decimal.js');

export default {
  name: 'home',
  components: {
    PieChart,
    SysMessage,
    ElSelect: Select,
    ElOption: Option,
    ElPagination: Pagination
  },
  data() {
    return {
      timer: '',
      now: '',
      sysMessage: [],
      isShow: false,
      curItem: {},
      dataArr: [],
      percent: [],
      term: 1,
      year: new Date().getFullYear(),
      years: [],
      terms: [],
      colorList: [
        '#749f83',
        '#91c7ae',
        '#ca8622',
        '#bda29a',
        '#6e7074',
        '#c23531',
        '#2f4554',
        '#61a0a8',
        '#d48265',
        '#42312c',
        '#61a0a8',
        '#c4ccd3',
        '#F4E001',
        '#F0805A',
        '#26C0C0'
      ],
      page: {
        page_no: 1,
        total: 0
      }
    };
  },
  computed: {
    user_id() {
      return this.$route.params.user_id;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  mounted() {
    this.getCur();
    this.chart();
    this.$store.dispatch('schoolYear/getTermAndYearList').then(list => {
      if (list) {
        this.years = list.year;
        this.terms = list.term;
      }
    });
  },
  methods: {
    showDetail(item) {
      this.curItem = item;
      this.readMsg(item.id);
      this.isShow = true;
    },
    currentChange(page_no) {
      this.page.page_no = page_no;
      this.getCur();
    },
    getCur() {
      sys
        .getSysMsg({
          receive_user_id: this.user_id,
          page_no: this.page.page_no,
          page_size: 5
        })
        .then(({ data }) => {
          this.page = {
            page_no: data.page_no,
            total: data.total
          };
          this.sysMessage = data.list;
        });
    },
    goto() {
      this.$message.info('敬请期待！');
      // this.$router.push(`/${this.user_id}${path}`);
    },
    gotoAll(path) {
      this.$router.push(`/${this.user_id}${path}`);
    },
    readMsg(msg_id) {
      sys
        .delSysMsg({
          methold: 'patch',
          msg_id
        })
        .then(() => this.getCur());
    },
    chart() {
      const data = [];
      pieChart({
        params: {
          term: this.term,
          year: this.year
        }
      }).then(res => {
        if (res) {
          res.data.list.map((item, index) => {
            let color = this.colorList[index];
            if (!color) {
              color = `#${Math.random().toString(16).substr(2, 6).toUpperCase()}`;
            }
            data.push([item.amount, color, item.name]);
            return item;
          });
          this.dataArr = data;
        }
      });
    },
    percentSet(percent) {
      let maxIndex = 0;
      let total = 0;
      const list = [];
      percent.forEach((item, index) => {
        const now = Number((item * 100).toFixed(2));
        if (now > list[maxIndex]) maxIndex = index;
        total = Decimal.add(total, now).toNumber();
        list.push(now);
      });
      if (total) list[maxIndex] = Decimal.add(list[maxIndex], Decimal.sub(100, total)).toNumber();
      this.percent = list;
    }
  }
};
</script>

<style lang="less">
.index-home {
  margin: 0 10px;
  .content {
    padding: 20px;
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    .ly-card {
      flex-grow: 1;
      width: 48%;
      box-shadow: none;
      &.flow {
        width: 100%;
        li {
          border-radius: 2px;
          width: 150px;
          .num {
            font-size: 30px;
            font-weight: 700;
            color: @danger;
            padding-top: 10px;
          }
          .title {
            height: 42px;
          }
        }
      }
      &.apply ul {
        justify-content: start;
        li {
          width: 150px;
          height: 100px;
          margin-right: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          text-align: center;
        }
      }
    }
  }
  .sys {
    > .hd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      h3 {
        display: inline-block;
        margin-right: 10px;
      }
    }
    .item-ul li {
      width: 100%;
      margin-bottom: 5px;
      display: flex;
      align-items: center;
      padding: 10px 5px;
      color: #888;
      .info {
        .flex-1;
        margin-right: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .time {
        width: 150px;
      }
      &::before {
        content: '';
        display: block;
        width: 8px;
        height: 9px;
        border-radius: 8px;
        margin-right: 4px;
        margin-top: 1px;
      }
      &.no-read {
        color: #333;
        &::before {
          background: @danger;
        }
      }
    }
  }
  .item-ul {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-flow: wrap;
    padding: 0;
    margin: 0;
    li {
      list-style: none;
      padding: 20px;
      background: #f0f0f0;
      margin-bottom: 20px;
      cursor: pointer;
    }
  }
  .color-block {
    display: inline-block;
    width: 15px;
    height: 10px;
    margin-bottom: 2px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .native-table .title-hd {
    display: inline-block;
    min-width: 120px;
    text-align: left;
  }
}
</style>
